import sliceCreator from '../../index.jsx';
import {GET_ALL_TENANT_USER} from '../../../constants/index.jsx';
const _getAllTenantUserAction = sliceCreator('GET_ALL_TENANT_USER', GET_ALL_TENANT_USER, 'get');

const { asyncAction: getAllTenantUserAction, reducer, clearData: clearGetAllTenantUserAction } = _getAllTenantUserAction;

export default reducer;

export {
    getAllTenantUserAction,
    clearGetAllTenantUserAction
}